
    <div style="margin-left: 39%;" *ngIf="loading">
        <mat-spinner> </mat-spinner>
    </div>

<div *ngIf="loading==false" class="flex-container">
  <div class="panel__content no-padding">
      <table class="table table--striped table--full-width">
          <thead>
              <!-- <tr>
                  <th class="right-align schematicName">{{schematicDetails.Name}}</th>
              </tr> -->

              <tr style="text-align-last: center;">
                <th class="right-align schematicName">{{schematicDetails.Name}}
                <!-- <mat-icon  style="margin-left: 14px; cursor: pointer;" title="Add Observation Point or Crack"
                (click)="openSchematicWindow(schematicDetails)">add_location_alt</mat-icon> -->
            </th>
            </tr>
          </thead>
          <tbody>
              <tr>
                  <td>
                      <app-schematic-observation-points [SchematicOP]="ObservationPointDetails" [schematicData]="schematicDetails" style="position: relative;" [isCrack]="1"></app-schematic-observation-points>
                    
                  </td>
              </tr>
          </tbody>
      </table>
  </div>
  <div class="panel__content no-padding">
      <table class="table table--full-width table--striped table--hover ng-tns-c6-16 ng-star-inserted"  style="font-size: small;">

          <thead>
              <tr>
                  <th >Component Type</th>
                  <th >Component Name</th>
                  <th >Observation Point</th>
                  <th style="text-align: center">OP Type</th>
                  <th >Diss-Assembly Condition</th>
                  <th >% Completion</th>
                  <th >Status</th>
                  <!-- <th >Post Condition</th> -->
                  <th >Hours to Repair</th>
                  <th>Cost To Repair</th>
                  <th >Inspection History</th>
                  <th >Approvals</th>
              </tr>
          </thead>
          <tbody>
              <ng-container *ngFor="let OP of ObservationPointDetails">
                  <tr >
                        <td class="CelltextWrap columncell" title="{{OP.CompTypeName}}" (click)="OpenRecommendation(OP.Id)">{{OP.CompTypeName}}</td>
                      <td class="CelltextWrap columncell" title="{{OP.ComponentName}}" (click)="OpenRecommendation(OP.Id)">{{OP.ComponentName}}</td>
                      <td class="CelltextWrap columncell" title="{{OP.Name}}" (click)="OpenRecommendation(OP.Id)">{{OP.Name}}</td>
                      <td class="columncell" (click)="OpenRecommendation(OP.Id)">{{OP.Type}}</td>
                      <td (click)="OpenRecommendation(OP.Id)">
                          <ng-container *ngIf="OP.Eval == ''">
                              <div class="{{getEvalClass(OP.WornPct)}}">
                                  {{OP.WornPct}}%
                              </div>
                          </ng-container>
                          <ng-container *ngIf="OP.Eval != ''">
                              <div class="{{getEvalClass2(OP.Eval)}}">
                                  {{OP.Eval}}
                              </div>
                          </ng-container>
                      </td>
                      <td (click)="OpenRecommendation(OP.Id)">
                          <ng-container>
                              <div class="columncell">{{OP.CompletePercentage}}</div>
                          </ng-container>
                      </td>
                      <td (click)="OpenRecommendation(OP.Id)">{{OP.ObStatus}}</td>

                      <!-- <td (click)="OpenRecommendation(OP.Id)">
                        <ng-container *ngIf="OP.ObPointTypeId!=3">
                            <div class="{{getEvalClass(OP.PostWorn)}}">
                                {{OP.PostWorn}}%
                            </div>
                        </ng-container>
                        <ng-container *ngIf="OP.ObPointTypeId==3">
                            <div class="{{getEvalClass2(OP.PostEval)}}">
                                {{OP.PostEval}}
                            </div>
                        </ng-container>
                    </td> -->

                      <td (click)="OpenRecommendation(OP.Id)">{{OP.RepairHours}}</td>
                      
                    
                      <td (click)="OpenRecommendation(OP.Id)">
                          <ng-container>
                              <div class="columncell">{{OP.RepairCost}}</div>
                          </ng-container>
                      <td  >
                        <ng-container>
                            <i class="material-icons square-button__icon" target="_blank"
                            routerLink="/fecr/obspointhistory/{{implementId}}/{{OP.Id}}" >history</i>
                        </ng-container>
                      </td>
                      
                      
                      <td (click)="OpenRecommendation(OP.Id)"> 
                          <span [ngClass]="getApprovalColour(OP.Apporval, OP.ApprovalRespone)">
                            <div>  {{OP.Apporval==true?'Yes':'No'}} </div>
                           
                        </span>
                        </td>
                  </tr>
              </ng-container>
          </tbody>
      </table>
  </div>
</div>